
import { supabase } from "@/integrations/supabase/client";

export const fetchRemovedClientsCount = async (days: number) => {
  let removedCount = 0;
  let previousPeriodCount = 0;
  
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const now = new Date();
      const cutoffDate = new Date(now.getTime() - (days * 24 * 60 * 60 * 1000));
      const previousCutoffDate = new Date(cutoffDate.getTime() - (days * 24 * 60 * 60 * 1000));
      
      const { data: currentData } = await supabase
        .from('removed_clients')
        .select('*')
        .eq('coach_id', user.id)
        .gte('removed_at', cutoffDate.toISOString());
      
      const { data: previousData } = await supabase
        .from('removed_clients')
        .select('*')
        .eq('coach_id', user.id)
        .gte('removed_at', previousCutoffDate.toISOString())
        .lt('removed_at', cutoffDate.toISOString());
      
      if (currentData) removedCount = currentData.length;
      if (previousData) previousPeriodCount = previousData.length;
    }
  } catch (error) {
    console.error(`Error fetching removed clients for last ${days} days:`, error);
  }
  
  return { currentCount: removedCount, previousCount: previousPeriodCount };
};
